import styled from 'styled-components';

export const LayoutContainer = styled.div`
  display: flex;
  position: relative;
`;

export const ContentContainer = styled.main`
  flex-grow: 1;
  margin-left: 250px;
  padding: 30px;
  min-height: 100vh;
  transition: filter 0.3s ease-in-out;
  
  @media (max-width: 768px) {
    margin-left: 0;
    padding: 20px;
    padding-top: 70px;
    filter: ${props => (props.$isNavOpen ? 'blur(5px)' : 'none')};
  }
`;

export const MobileNavToggle = styled.button`
  display: none;
  position: fixed;
  top: 15px;
  left: 15px;
  z-index: 2001; /* Above the SideNav */
  background: none;
  border: none;
  color: ${({ theme }) => theme.heading};
  cursor: pointer;
  
  @media (max-width: 768px) {
    display: block;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1999; /* Below the SideNav */
  opacity: ${props => (props.$isOpen ? '1' : '0')};
  visibility: ${props => (props.$isOpen ? 'visible' : 'hidden')};
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
`;